var _path, _path2, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_8450)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_8450",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_8450)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 14.6667C16.5772 14.6667 18.6666 12.5774 18.6666 10C18.6666 7.42271 16.5772 5.33337 13.9999 5.33337C11.4226 5.33337 9.33325 7.42271 9.33325 10C9.33325 12.5774 11.4226 14.6667 13.9999 14.6667Z",
    fill: "#E01B41"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2858_8450",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 10,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 14.6667C16.5772 14.6667 18.6666 12.5774 18.6666 10C18.6666 7.42271 16.5772 5.33337 13.9999 5.33337C11.4226 5.33337 9.33325 7.42271 9.33325 10C9.33325 12.5774 11.4226 14.6667 13.9999 14.6667Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2858_8450)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33332 10.6667C10.6666 11.9167 12.6666 12.6667 14 10.6667C15.3333 8.66675 18 8.66675 18.6666 10.6667C19.3333 12.6667 18.6666 14.6667 18.6666 14.6667H9.33332C9.33332 14.6667 7.99998 9.41675 9.33332 10.6667Z",
    fill: "#0E4B9C"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6604 3.26794L20.5056 3.93461L22.5056 7.39871L23.6604 6.73205L21.6604 3.26794ZM19.9283 4.26794L18.7736 4.93461L20.7736 8.39871L21.9283 7.73205L19.9283 4.26794ZM4.33984 13.2679L5.49454 12.6013L7.49454 16.0654L6.33984 16.732L4.33984 13.2679ZM7.2266 11.6013L6.07189 12.2679L8.07189 15.732L9.2266 15.0654L7.2266 11.6013ZM20.7736 11.6013L21.9283 12.2679L19.9283 15.732L18.7736 15.0654L20.7736 11.6013ZM23.6604 13.2679L22.5056 12.6013L20.5056 16.0654L21.6604 16.732L23.6604 13.2679ZM6.33984 3.26794L7.49454 3.93461L5.49454 7.39871L4.33984 6.73205L6.33984 3.26794ZM9.2266 4.93461L8.07189 4.26794L6.07189 7.73205L7.22659 8.39871L9.2266 4.93461Z",
    fill: "#262626"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_8450"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryKr);
export default __webpack_public_path__ + "static/media/Country=KR.2a6f1bd9477eca48bed6ddf97df6903a.svg";
export { ForwardRef as ReactComponent };